module.exports = __webpack_public_path__ + "img/Martin.40b99b17.png";